import { memberApiV2 } from '../../../lib/api';

export function getInitialPatients(providerId: string) {
  return memberApiV2.customV2('/management/private/client/search', providerId, {
    method: 'POST',
    data: {
      page: 1,
      pageSize: 10,
      sortBy: 'lastName',
      direction: 'ASC',
      name: null,
    },
  });
}

export function getPatients(providerId: string, namePart: string) {
  return memberApiV2.customV2('/management/private/client/search', providerId, {
    method: 'POST',
    data: {
      page: 1,
      pageSize: 10,
      sortBy: 'lastName',
      direction: 'ASC',
      name: namePart,
    },
  });
}

export function createOrder(providerId: string, data: any) {
  return memberApiV2.customV2('/management/private/calendar/order', providerId, {
    method: 'POST',
    data: {
      ...data,
    },
  });
}

export function updateOrder(providerId: string, { orderId, ...data }: any) {
  return memberApiV2.customV2('/management/private/calendar/order/' + orderId, providerId, {
    method: 'PUT',
    data,
  });
}
